export default "__VITE_PUBLIC_ASSET__325916b2__"